"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../../styling/videoStyles");
const Icons_1 = tslib_1.__importDefault(require("../../Icons"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
function CloseButton({ onClick, active = null, classes = {}, icon, open, iconColor, label, id, activeId, inActiveId, ...rest }) {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "closeButton");
    const proppedIcon = icon || react_1.default.createElement(Icons_1.default, { iconName: "close", classes: classes.icon, style: { height: "16px" } });
    (0, react_1.useEffect)(() => {
        const escKeyPressed = (event) => {
            if (event.key === "Escape" && open === true) {
                if (onClick != null) {
                    onClick();
                }
            }
        };
        window.addEventListener("keydown", escKeyPressed, false);
        return () => {
            window.removeEventListener("keydown", escKeyPressed, false);
        };
    }, [onClick, open]);
    return (
    // eslint-disable-next-line react/button-has-type
    react_1.default.createElement("button", { title: label !== null && label !== void 0 ? label : "close button", className: `${mergedClasses.root} close`, onClick: onClick !== null && onClick !== void 0 ? onClick : undefined, "data-selenium": "close-button", id: id, "data-active-id": active != null && activeId, "data-inactive-id": active == null && inActiveId, ...rest }, proppedIcon));
}
exports.default = CloseButton;
//# sourceMappingURL=index.js.map